import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { useHistory } from 'react-router-dom';
import { toggleMobileSidebar } from 'containers/App/actions';
import { makeSelectMobileSidebarOpen } from 'containers/App/selectors';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import orderBy from 'lodash/orderBy';
import {
  MenuList,
  MenuListItem,
} from '@pearsontechnology/aero-components';
import Sidebar, { SidebarOverlay } from 'components/Sidebar';
import NavHead from 'components/Navigation/NavHead';
import enhanceWithThemes from 'hocs/enhanceWithThemes';
import workspaceShape from 'Workspace/types/workspace';
import { selectWorkspacesList, selectWorkspace } from 'Workspace/Admin/store/selectors';
import workspaceService from 'services/WorkspaceService';
import { Transition } from 'react-transition-group';

import themes from '../themes';
import {
  MenuItemTitle,
  SidebarWrapper,
  StyledDropDownSelect,
  StyledMenu,
  MenuItemTitleDefault,
  LineBreak,
} from './styles';

const Dashboard = {name: 'Dashboard', id: 'Dashboard'};

const WorkspaceSidebar = ({navigation: navItems, workspaces, currentWorkspace, toggleSidebar, mobileSidebarOpen, ...restProps}) =>{
  const [{name: selectedWorkspaceName, id: selectedWorkspaceId}, setWorkspace ] = useState(Dashboard);
  const [sortedWorkspace, setSortedWorkspace] = useState([]);
  const history = useHistory();

  const selectWorkspace = (workspace) => () => {
    workspaceService.setSelectedWorkspace(workspace);
    if(workspace.id === 'Dashboard') {
      history.push('/dashboard');
    } else {
      history.push('/courseware');
    }
  };

  useEffect(()=>{
    const handleKeydown = (event) => {
      if (event.code === 'Escape') {
        toggleSidebar(false);
      }
    }; 

    const sortWorkspace = () => {
      const sortedWorkspace = orderBy(workspaces, (workspace) =>
        `${workspace.name.trim().toLowerCase()}-${workspace.id}`, 'asc');
      setSortedWorkspace(sortedWorkspace);
    };

    setWorkspace(workspaceService.getSelectedWorkspace());
    sortWorkspace();
    document.addEventListener('keydown', handleKeydown);
    setTimeout(() => toggleSidebar(false));
    return ()=>{ document.removeEventListener('keydown', handleKeydown);};
  },[toggleSidebar, workspaces, currentWorkspace]);

  return(<Fragment>
    <Transition
      mountOnEnter
      unmountOnExit
      in={mobileSidebarOpen}
      onEnter={(node) => node && node.offsetHeight}
      timeout={400}
    >
      {(status) =>
        <SidebarOverlay status={status} onClick={() => toggleSidebar(false)} />
      }
    </Transition>
    <Sidebar data-testid='sideBar' mobileSidebarOpen={mobileSidebarOpen} {...restProps}>
      <SidebarWrapper>
        <NavHead/>
        <StyledDropDownSelect text={selectedWorkspaceName} hidepopperonclick>
          <StyledMenu>
            <MenuList>
                  <>
                  <MenuListItem
                    key={Dashboard.id}
                    selected={selectedWorkspaceName === Dashboard.name}
                    onClick={selectWorkspace(Dashboard)}
                  >
                    <MenuItemTitleDefault>
                    Dashboard
                    </MenuItemTitleDefault>
                  </MenuListItem>
                  <LineBreak />
                  {
                    sortedWorkspace && sortedWorkspace.map(({id, name}) => {
                      const selected = id === selectedWorkspaceId;
                      return (
                        <MenuListItem
                          key={id}
                          selected={selected}
                          onClick={selectWorkspace({id, name})}
                        >
                          <MenuItemTitle>
                            {name}
                          </MenuItemTitle>
                        </MenuListItem>
                      );
                    })
                  }
                  </>
            </MenuList>
          </StyledMenu>
        </StyledDropDownSelect>
        { selectedWorkspaceName !== Dashboard.name && navItems }
      </SidebarWrapper>
    </Sidebar>
  </Fragment>);

};

WorkspaceSidebar.propTypes = {
  navigation: PropTypes.element,
  workspaces: PropTypes.arrayOf(workspaceShape),
  toggleSidebar: PropTypes.func,
  mobileSidebarOpen: PropTypes.bool,
  currentWorkspace: PropTypes.object,
};

const mapStateToProps = createStructuredSelector({
  workspaces: selectWorkspacesList,
  mobileSidebarOpen: makeSelectMobileSidebarOpen(),
  currentWorkspace: selectWorkspace,
});

const mapDispatchToProps = (dispatch) => ({
  toggleSidebar: (value) => dispatch(toggleMobileSidebar(value)),
});
  
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(enhanceWithThemes(WorkspaceSidebar,themes));